import * as signalR from '@microsoft/signalr';

const baseUrl = process.env.NEXT_PUBLIC_TRIPS_API_URL;
let currentConnection = null;
let tryConnect = false;
export async function setNotes(token, tripId, notes, organizationId) {
  const response = await fetch(`${baseUrl}/trip/${tripId}/notes`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      notes: notes ? [notes] : [],
    }),
  });

  const data = await response.text();
  if (response.status !== 200) {
    throw Error('Error calling POST "/trip/:tripId/notes"');
  }

  return {
    ...data,
  };
}

export async function getTripNumber(token, organizationId, carrierId, directionTrip) {
  let url = `${baseUrl}/trip-number?carrierId=${carrierId}`;
  if (directionTrip) {
    url += `&directionTrip=${directionTrip}`;
  } const response = await fetch(url, {

    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();
  return {
    success: response.status === 200,
    ...data,
  };
}

export async function verifyTripNumber(token, tripNumber, carrierId, organizationId, directionTrip) {
  let url = `${baseUrl}/trip-number/${tripNumber}?carrierId=${carrierId}`;
  if (directionTrip) {
    url += `&directionTrip=${directionTrip}`;
  }
  const response = await fetch(url,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'flex-organization': organizationId,
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const data = await response.json();
  return {
    ...data,
    status: response.status,
  };
}

export async function saveTrip(token, body, organizationId) {

  const response = await fetch(`${baseUrl}/trip`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  let result;
  if (response.status === 400 || response.status === 500) {
    result = await response.json();
    return { success: false, result };
  }
  result = await response.json();
  return {
    success: response.status === 200,
    result,
  };
}

export async function copyTrip(token, body, organizationId) {
  const response = await fetch(`${baseUrl}/copy-trip`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  let result;
  if (response.status === 400 || response.status === 500) {
    result = await response.json();
    return { success: false, result };
  }
  result = await response.json();
  return {
    success: response.status === 200,
    result,
  };
}


export async function saveTripAndShipments(token, body, shipments, organizationId) {
  const newBody = { ...body };
  delete newBody.shipments;

  // TODO: enviar solo la cabecera del viaje
  const response = await fetch(`${baseUrl}/trip-header`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(newBody),
  });

  const result = await response.json();

  if (response.status === 400 || response.status === 500) {
    return { success: false, result };
  }

  // TODO: enviar con un for, cada lote de shipments

  if (shipments && result.tripId) {
    try {
      const responseShipments = await fetch(`${baseUrl}/trip/add-shipments-to-trip`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'flex-organization': organizationId,
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ shipments: shipments, tripNumber: body?.tripNumber, scac: body?.carrier?.scac }),
      });

      const shipmentsResult = await responseShipments.json();
      const validationErrors = shipmentsResult?.validationErrors || [];

      if (responseShipments.status === 200 && !validationErrors.length) {
        return { success: true, result, message: "Shipments have been added in queue" };
      }

      // add-shipments-to-trip valida igual que /trip (sincrónico, antes de encolar), pero
      // devuelve los errores como { validationErrors: [{ Message, Detail }] } en vez de
      // { details: [{ message }] }; se normaliza aquí para que el render de errores del
      // formulario (que lee response.result.details[0].message) siga funcionando igual.
      console.error('Shipment request failed:', responseShipments.status);
      const details = validationErrors.length
        ? validationErrors.map((error) => ({ message: error.Message || error.Detail || error.message }))
        : [{ message: shipmentsResult?.message || 'Error adding shipments' }];

      return { success: false, result: { ...result, details } };
    } catch (error) {
      console.error('Error occurred during shipment request:', error);
      return { success: false, result: { ...result, details: [{ message: 'Error adding shipments' }] } };
    }
  }

  return {
    success: response.status === 200,
    result,
  };
}


export async function sendTripBulk(token, body, organizationId) {
  const response = await fetch(`${baseUrl}/trip-bulk/send`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });


  let result;

  return {
    success: response.status === 200,
    result,
  };
}

export async function editTrip(token, tripId, body, organizationId) {
  const response = await fetch(`${baseUrl}/trip/${tripId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  let result;
  if (response.status === 400 || response.status === 500) {
    result = await response.json();
    return { success: false, result };
  }
  result = await response.json();
  return {
    success: response.status === 200,
    result,
  };
}

export async function fetchTrips(token, organizationId, signal = null) {
  const response = await fetch(`${baseUrl}/trips`, {
    signal,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status === 200) {
    const data = await response.json();
    return {
      success: true,
      ...data,
    };
  }
  return { success: false };
}

export async function getTripById(token, tripId, organizationId, fullTrip = false, limitShipmentEvents = false, shipments = false) {
  let url = `${baseUrl}/trips/${tripId}?fullTrip=${fullTrip}`;
  if (limitShipmentEvents) {
    url += `&limitShipmentEvents=${limitShipmentEvents}`;
  }
  if (shipments) {
    url += `&shipments=${shipments}`;
  };
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
  });

  const parseNotes = (notes) => (notes && notes.length ? notes[0].content : '');
  const data = await response.json();

  if (response.status === 200) {


    return {
      success: true,
      ...data,
      trip: {
        ...data.trip,
        notes: parseNotes(data?.trip?.notes || []),
      },
    };

  }

  return { success: false, organizationId: data.organizationId };
}

export async function getTripAndShipments(token, tripId, organizationId, fullTrip = false) {
  const response = await fetch(`${baseUrl}/trips/${tripId}?fullTrip=${fullTrip}&shipments=${true}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
  });

  const parseNotes = (notes) => (notes && notes.length ? notes[0].content : '');
  const data = await response.json();
  if (response.status === 200) {


    return {
      success: true,
      ...data,
      trip: {
        ...data.trip,
        notes: parseNotes(data?.trip?.notes || []),
      },
    };

  }

  return { success: false, organizationId: data.organizationId };
}

export async function deleteTrip(token, tripId, organizationId) {
  const response = await fetch(`${baseUrl}/trips/${tripId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
  });
  return { success: response.status === 200 };
}

export async function getScnsByTrip(token, tripId, organizationId, scn) {

  let url = `${baseUrl}/trip/scns/${tripId}`;

  if (scn) {
    url += `?scn=${encodeURIComponent(scn)}`;
  }

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    }
  });
  const data = await response.json();
  if (response.status === 200) {
    return {
      success: true,
      scns: data.scns

    };
  }

  return { success: false, message: "Error fetching events" };
}

export async function getTripEvents(token, tripId, organizationId, scn) {
  let url = `${baseUrl}/trip/events/${tripId}`;

  // Si scn no es null, lo agregamos como un parámetro de consulta en la URL
  if (scn) {
    url += `?scn=${encodeURIComponent(scn)}`;
  }

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    }
  });
  const data = await response.json();
  if (response.status === 200) {
    return {
      success: true,
      ...data,
      events: {
        ...data.events
      },
    };
  }

  return { success: false, message: "Error fetching events" };
}

export async function filterDashboardTripsBy(
  token,
  organizationId,
  filters,
  signal = null,
) {
  const url = new URL(`${baseUrl}/dashboard`);


  Object.keys(filters).forEach((key) => {
    let paramValue = filters[key];
    if (paramValue) {
      if (paramValue instanceof Array) {
        if (paramValue.length) {
          paramValue = paramValue.join(',');
          url.searchParams.append(key, paramValue);
        }
      } else {
        url.searchParams.append(key, paramValue);
      }
    }
  });
  const urlParams = url.searchParams.toString().replace(/%2C/g, ',');

  const response = await fetch(`${baseUrl}/dashboard?${urlParams}`, {
    signal,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
  });


  let data;
  if (response.status === 200) {
    data = await response.json();

    return {
      success: true,
      ...data,
    };
  }
  data = await response.json();
  return { success: false, response: data };
}

export async function filterTripsBy(token, organizationId, filters, signal = null) {
  const url = new URL(`${baseUrl}/trips`);

  Object.keys(filters).forEach((key) => {
    let paramValue = filters[key];

    if (paramValue) {
      if (paramValue instanceof Array) {
        if (paramValue.length) {
          paramValue = paramValue.join(',');
          url.searchParams.append(key, paramValue);
        }
      } else {
        url.searchParams.append(key, paramValue);
      }
    }
  });
  const urlParams = url.searchParams.toString().replace(/%2C/g, ',');
  const response = await fetch(`${baseUrl}/trips?${urlParams}`, {
    signal,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
  });

  let data;
  if (response.status === 200) {
    data = await response.json();
    return {
      success: true,
      ...data,
    };
  }
  data = await response.json();
  return { success: false, response: data };
}

export async function sendTrip(token, tripId, organizationId, body = null) {

  const response = await fetch(`${baseUrl}/trip/${tripId}/send`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  let result;
  if (response.status === 400 || response.status === 500) {
    result = await response.json();
    return { success: false, result };
  }
  result = await response.text();
  return {
    success: response.status === 200,
    result: result ? JSON.parse(result) : null,
  };
}

export async function startListenEvents(organizationId) {
  // Si ya hay una conexión establecida, no intentamos reconectar
  if (currentConnection && currentConnection.state === signalR.HubConnectionState.Connected) {

    return currentConnection;  // Retorna la conexión existente
  }

  // Si ya estamos en proceso de conexión, esperamos un tiempo antes de intentar nuevamente
  if (tryConnect) {

    return new Promise((resolve) => {
      // Esperamos 10 segundos antes de intentar de nuevo
      setTimeout(() => resolve(startListenEvents(organizationId)), 5000);
    });
  }

  try {
    tryConnect = true;  // Marcamos que estamos intentando conectar

    const response = await fetch(`${baseUrl}/onConnectionMessage`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-ms-client-principal-id': organizationId,
      },
    });

    const { url: connectionUrl, accessToken } = await response.json();

    // Construimos la conexión SignalR
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(connectionUrl, {
        accessTokenFactory: () => accessToken,
      })
      .withAutomaticReconnect()
      .build();

    // Intentamos iniciar la conexión
    await connection.start();
    currentConnection = connection;  // Guardamos la conexión activa

    tryConnect = false;  // Restablecemos el estado de conexión

    return connection;
  } catch (error) {
    tryConnect = false;  // Restablecemos el estado de conexión en caso de error
    console.error("Error al conectar signalR:", error);

    // Reintentamos la conexión después de 5 segundos si falló
    setTimeout(() => startListenEvents(organizationId), 5000);
  }
}


/*export async function startListenTripEvents(organizationId) {
  const response = await fetch(`${baseUrl}/onConnectionMessage`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'x-ms-client-principal-id': organizationId,
    },
  });
  const { url: connectionUrl, accessToken } = await response.json();
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(connectionUrl, {
      accessTokenFactory: () => accessToken,
    })
    .withAutomaticReconnect()
    .build();
  await connection.start().catch((er) => {
    console.error("Error al conectar signalr", er)
  });
  return connection;
}*/

export async function saveIITSeals(token, tripId, organizationId, body) {
  const response = await fetch(`${baseUrl}/trip/${tripId}/iitseals`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  return {
    success: response.status === 200,
  };
}

export async function getTripsPaginated(
  token,
  organizationId,
  { pageNumber, totalPerPage }
) {
  const response = await fetch(
    `${baseUrl}/trips?pageNumber=${pageNumber}&totalPerPage=${totalPerPage}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'flex-organization': organizationId,
        Authorization: `Bearer ${token}`,
      },
    }
  );

  const data = await response.json();
  return data;
}

export async function updateTripsConveyance(token, tripId, organizationId, body) {
  const response = await fetch(`${baseUrl}/trip/${tripId}/conveyance`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  return {
    success: response.status === 200,
  };
}

export async function updateTripsEquipment(token, tripId, organizationId, body) {
  const response = await fetch(`${baseUrl}/trip/${tripId}/equipment`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  return {
    success: response.status === 200,
  };
}

export async function updateTripsDriver(token, tripId, organizationId, body) {
  const response = await fetch(`${baseUrl}/trip/${tripId}/driver`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  return {
    success: response.status === 200,
  };
}

export async function updateTripsPassenger(token, tripId, organizationId, body) {
  const response = await fetch(`${baseUrl}/trip/${tripId}/passenger`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  return {
    success: response.status === 200,
  };
}

export async function fetchTripByTripNumber(token, organizationId, tripNumber) {
  const response = await fetch(`${baseUrl}/trips?tripNumber=${tripNumber}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();
  return data;
}

export async function fetchTripsByTripNumber(token, organizationId, tripNumber) {
  const response = await fetch(`${baseUrl}/search-trips-by-number?tripNumber=${tripNumber}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await response.json();
  return data;
}

export async function fetchTripsByScn(token, organizationId, scn) {
  const response = await fetch(`${baseUrl}/search-trip-by-scn?scn=${scn}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await response.json();
  return data;
}

export async function getAllTrips(token, organizationId, tripNumber) {
  const response = await fetch(`${baseUrl}/all-trips?tripNumber=${tripNumber}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();
  return data;
}


export async function getDashboardTrips(token, organizationId) {
  const response = await fetch(`${baseUrl}/dashboard-trips`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();
  return data;
}
export async function getDashboardChannel(token, organizationId) {
  const response = await fetch(`${baseUrl}/dashboard-channel`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();
  return data;
}

export async function getTripReport(token, organizationId, body) {
  try {
    const response = await fetch(`${baseUrl}/trip-report`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'flex-organization': organizationId,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body)
    });

    const data = { success: true, data: await response.json() };
    return data;
  } catch (error) {
    console.error("Error loading trip report:", error);
    return { success: false, message: t("Error loading trip report. Please try a shorter date range.") };
  }
}

export async function getMonthlyReport(token, organizationId, body) {
  const response = await fetch(`${baseUrl}/monthly-report`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body)
  });

  const data = await response.json();
  return data;
}

export async function updateTenantsAndChannels(token, organizationId, body) {
  const response = await fetch(`${baseUrl}/update-channels/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  return {
    success: response.status === 200,
  };
}

export async function getShipmentStatus(tripId, token, organizationId) {
  const response = await fetch(`${baseUrl}/trip/${tripId}/shipments-status`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await response.json();
  return data;
}

export async function getDocument(tripId, token, organizationId, documentType, showFast = false, timeZone = null) {
  const response = await fetch(`${baseUrl}/get-document?tripId=${tripId}&documentType=${documentType}?showFast=${showFast}&timeZone=${encodeURIComponent(timeZone)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'flex-organization': organizationId,
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await response.json();
  return data;
}
